<template>
  <v-sheet class="login responsive-sheet">
    <h2 class="titulo">Selección de modo</h2>
    <div class="inside">
      <v-form fast-fail @submit.prevent="handleSubmit">
        <v-autocomplete
          v-model="facturador"
          variant="solo"
          :items="opcionesFacturador"
          :item-title="titleFacturador"
          return-object
          :rules="obligatorio"
          :loading="loadEst"
          label="Facturador"
          required
          @update:model-value="loadModos"
          class="asterisco"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item v-bind="props" :subtitle="item.raw.direccion"></v-list-item>
          </template>
          <template #message>
            <span v-if="!valid" class="custom-error-message">Por favor seleccione un facturador.</span>
          </template>
        </v-autocomplete>
        <v-select
          v-model="modo"
          variant="solo"
          :items="opcionesModo"
          item-title="nombre"
          return-object
          :rules="obligatorio"
          :disabled="disModo"
          :loading="loadModo"
          label="Modo"
          required
          class="asterisco"
        >
          <template #message>
            <span v-if="!valid" class="custom-error-message">Por favor seleccione un modo.</span>
          </template>
        </v-select>
        <v-btn type="submit" block color="#bec0b5">Seleccionar</v-btn>
      </v-form>
      <v-container class="d-flex justify-center align-center">
        <Loader v-if="cargando"></Loader>
      </v-container>
    </div>
  </v-sheet>
  <AlertComponent
    :title="alertTitle"
    :text="alertText"
    :alertType="alertType"
    :showAlert="showAlert"
    @close="showAlert = false"
  />
</template>

<style scoped>
.login {
  background-image: url(../../public/register-bg.jpg);
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #bec0b5;
  border-radius: 12px;
}
.responsive-sheet {
  width: 25%;
}
@media (max-width: 810px) {
  .responsive-sheet {
    width: 70%;
  }
}
.inside {
  padding: 7%;
}
.titulo {
  text-align: center;
  color: #bec0b5;
  padding-top: 2%;
}
.custom-error-message {
  color: rgb(228, 253, 226);
  font-size: 14px;
  margin-left: 4px;
}
</style>

<script>
import "sweetalert2/dist/sweetalert2.min.css";
import AuthService from "@/api/AuthService";
import FacturadorService from "@/api/FacturadorService";
import Loader from "./Loader.vue";
import { Role } from "@/_helpers/role";
import { obligatorio } from "@/_helpers/rules";
import AlertComponent from "@/components/AlertComponent.vue";
import GeneralService from "@/api/GeneralService";

const generalService = new GeneralService();

export default {
  components: {
    Loader,
    AlertComponent,
  },
  data() {
    return {
      authService: new AuthService(),
      facturadorService: new FacturadorService(),
      usuNivEst: [],
      loadEst: false,
      disEst: true,
      facturador: "",
      opcionesFacturador: [],
      loadModo: false,
      disModo: true,
      modo: "",
      opcionesModo: this.$store.getters.getModos,
      obligatorio: obligatorio,
      cargando: false,
      //datos para avisos
      showAlert:false,
      alertTitle: '',
      alertText: '',
      alertType: '',
    };
  },
  methods: {
    async handleSubmit() {
      this.cargando = true;
      if(!this.facturador || !this.modo){
        this.cargando = false;
        return;
      }
      if(!this.facturador.esEstablecimiento){
        this.$store.commit("setProfesional", this.facturador.profesional);
      }
      else{
        this.$store.commit("removeProfesional");
      }
      this.$store.commit("setFacturador", {
        id: this.facturador.id,
        nombre: this.facturador.nombre,
        cuit: this.facturador.cuitFacturador,
      });
      this.$store.commit("setModoSeleccionado", this.modo.nombre);

      this.cargando = false;
      
      // let vista = this.$store.getters.getVista;
      // this.$router.push({ name: vista });
      this.redirigir();
    },
    async loadFacturadores() {
      this.disEst = true;
      this.loadEst = true;
      this.disModo = true;
      this.loadModo = false;
      this.opcionesFacturador =
        await this.facturadorService.getEstablecimientosUsuario(this.usuNivEst);
      this.loadEst = false;
      this.disEst = false;
    },
    async loadModos() {
      this.disModo = true;
      this.loadModo = true;
      this.opcionesModo = await this.facturadorService.getModosPorEstablecimiento(
        this.usuNivEst,
        this.facturador.id
      );
      this.modo = this.opcionesModo.find((m) => m.nombre === "Primer Nivel");
      this.loadModo = false;
      this.disModo = false;
    },
    titleFacturador(item) {
      if (!item) return '';
      return `${item.nombre} - ${item.cuitFacturador}`;
    },
    redirigir(){
      let redireccion = this.$store.getters.getRedireccion;
      if(redireccion){
        this.$router.push(redireccion);
      }
    },
    async mostrarAviso(){
      const response = await generalService.getAlertasActivas();
      if(response.status === 200){
        const alertas = response.data;
        if(alertas.length > 0){
            alertas.forEach(alerta => {
                this.alertTitle = 'Aviso importante';
                this.alertText = alerta.descripcion;
                this.alertType = 'info';
                this.showAlert = true;
            });
        }
      }
    }
  },
  async mounted() {
    await this.mostrarAviso();
    const role = this.$store.getters.getRole;
    if(role !== Role.AdministrativoFacturador && role !== Role.FacturadorIOMA){
      this.redirigir();
    }
    this.usuNivEst = await this.authService.getUsuarioNivelFacturador(
      localStorage.getItem("jwt")
    );
    if (this.usuNivEst) {
      if(this.usuNivEst.length === 1){
        this.$store.commit("setUnicoNivEst", true);
        this.facturador = this.usuNivEst[0].facturador;
        if(!this.facturador.esEstablecimiento){
          this.$store.commit("setProfesional", this.facturador.profesional);
        }
        else{
          this.$store.commit("removeProfesional");
        }
        this.$store.commit("setFacturador", {
          id: this.facturador.id,
          nombre: this.facturador.nombre,
          cuit: this.facturador.cuitFacturador,
        });
        this.$store.commit("setModoSeleccionado", this.usuNivEst[0].nivel.nombre);
        this.redirigir();
      }
      else{
        this.$store.commit("setUnicoNivEst", false);
        this.loadFacturadores();
      }
    }
  },
};
</script>
